var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_25859",
    "data-name": "Path 25859",
    d: "M32.655,22.161c-2.987,0-3.362.013-4.536.066a8.078,8.078,0,0,0-2.67.512,5.623,5.623,0,0,0-3.217,3.217,8.056,8.056,0,0,0-.511,2.67c-.054,1.173-.067,1.548-.067,4.536s.013,3.362.067,4.535a8.054,8.054,0,0,0,.511,2.67,5.625,5.625,0,0,0,3.217,3.217,8.08,8.08,0,0,0,2.67.511c1.173.053,1.548.066,4.536.066s3.362-.013,4.536-.066a8.079,8.079,0,0,0,2.67-.511,5.624,5.624,0,0,0,3.217-3.217,8.055,8.055,0,0,0,.511-2.67c.054-1.173.067-1.548.067-4.535s-.013-3.362-.067-4.536a8.058,8.058,0,0,0-.511-2.67,5.622,5.622,0,0,0-3.217-3.217,8.078,8.078,0,0,0-2.67-.512c-1.173-.053-1.548-.066-4.536-.066m0,5.351A5.649,5.649,0,1,0,38.3,33.161a5.648,5.648,0,0,0-5.649-5.649m0,9.315,7.192-9.539a1.32,1.32,0,1,0-1.32,1.32,1.32,1.32,0,0,0,1.32-1.32",
    transform: "translate(-21.154 -21.66)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramOutline);
export default __webpack_public_path__ + "static/media/instagram-outline.767478c63e65091146c8c50721d3f8c9.svg";
export { ForwardRef as ReactComponent };